export type PresetId = string;

export interface PresetFilter<T> {
  value: T;
  id: PresetId;
  name: string;
  isSelected: boolean;
}

export interface PresetFilterActions {
  onCreate?: VoidFunction;
  onEdit?: (presetId: PresetId) => void;
  onSelect: (presetId: PresetId) => void;
  onDelete?: (presetId: PresetId) => Promise<void>;
}

export enum PresetMode {
  OFF = 'off',
  CREATE = 'create',
  UPDATE = 'update',
}
